




































































































import Vue from "vue";

import { default as moment, Moment } from "moment-timezone";

import { currentTimestamp, PopoverMode } from "@/api/Termine";
import { Ausgabe, Transaktion } from "@/api/Abrechnung";

export interface KassenbuchUpdateEvent {
  popoverMode: PopoverMode;
  alteAusgabe: Ausgabe;
  ausgabe: Ausgabe;
}

export default Vue.extend({
  name: "KassenbuchPopover",
  data() {
    return {
      // Einstellungen für Popover-Dialog
      popoverMode: "create" as PopoverMode,
      popoverTitle: "",
      monat: "",
      showPopover: false,

      // Daten
      tag: 0,
      beleg: 0,
      bezeichnung: "",
      betrag: 0,
      betragEingabe: "",
      ausgabe: {} as Ausgabe,

      // Validierung
      betragFehler: false,
    };
  },
  methods: {
    show(popoverMode: PopoverMode, beleg: number, monat: string, transaktion?: Transaktion) {
      this.popoverMode = popoverMode;
      this.ausgabe = (transaktion?.typ == "ausgabe") ? transaktion as Ausgabe : {} as Ausgabe;
      this.tag = (transaktion?.tag || 7);
      this.monat = monat;
      this.beleg = this.ausgabe.beleg || beleg;
      this.bezeichnung = this.ausgabe.bezeichnung;
      this.betrag = this.ausgabe.betrag;
      this.betragEingabe = this.formatiereBetrag(this.betrag);
      console.log('Formatierter Preis: ' + this.betragEingabe);

      switch (popoverMode) {
        case "create":
          this.bezeichnung = "";
          this.betrag = 0;
          this.betragEingabe = "";
          // Fallthrough beabsichtigt
        case "duplicate":
          this.popoverTitle = `Neue Ausgabe buchen`;
          this.popoverMode = "create";
          this.beleg = beleg;
          break;

        case "edit":
          this.popoverTitle = `Ausgabe bearbeiten`;
          break;

        case "delete":
          this.popoverTitle = `Ausgabe löschen`;
          break;

        default:
          this.showPopover = false;
          return;
      }

      this.showPopover = true;
    },

    formatiereBetrag(betrag?: number) {
      return this.betrag ? Math.floor(this.betrag) + ',' + (""+Math.floor((this.betrag * 100) % 100)).padEnd(2, '0') : "";
    },

    updateBetrag(rest?: any) {
      const neuerBetrag = this.betragEingabe;
      console.log(neuerBetrag);
      console.log(rest);
      const punktPos = neuerBetrag.indexOf('.');
      const kommaPos = neuerBetrag.indexOf(',');
      let vorkomma = neuerBetrag, nachkomma = "00";
      if (kommaPos < punktPos) {
        vorkomma = neuerBetrag.substring(0, punktPos).replaceAll(',', '');
        nachkomma = neuerBetrag.substring(punktPos + 1);
      } else if (kommaPos >= 0) {
        vorkomma = neuerBetrag.substring(0, kommaPos).replaceAll('.', '');
        nachkomma = neuerBetrag.substring(kommaPos + 1);
      }
      if (nachkomma.length == 1) {
        nachkomma += "0";
      }
      this.betragFehler = nachkomma.length != 2;
      console.log("Berechne Betrag aus " + vorkomma + " und " + nachkomma);
      let fraction = Number.parseInt(nachkomma) / 100;
      while (fraction > 1) { fraction /= 10; }
      this.betrag = Number.parseInt(vorkomma) + fraction;
    },

    // Behandeln von Eingabemasken/Dialog für
    // Neuanlage/Bearbeitung/Löschung
    popoverYesSave() {

      this.showPopover = false;

      this.$emit("update", {
        popoverMode: this.popoverMode,
        alteAusgabe: this.ausgabe,
        ausgabe: {
          tag: this.tag,
          beleg: (this.beleg || 0) || undefined,
          bezeichnung: this.bezeichnung,
          betrag: this.betrag,
        } as Ausgabe,
      } as KassenbuchUpdateEvent);
    },
    popoverNoAbort() {
      this.showPopover = false;
    },
    popoverDelete() {
      if (
        window.confirm("Soll die gewählte Ausgabe wirklich gelöscht werden?")
      ) {
        this.$emit("update", {
          popoverMode: "delete",
          alteAusgabe: this.ausgabe,
          ausgabe: this.ausgabe,
        } as KassenbuchUpdateEvent);
        this.showPopover = false;
      }
    },
  },
});
